import { useRef, useState, useEffect } from 'react'
import { DayPicker } from 'react-day-picker'
import { usePopper } from 'react-popper'
import cn from 'classnames'
import s from './DatePicker.scss'
import { getDateFormat } from 'utils/authService'
import moment from 'moment'
import { OutsideClickContainer } from 'components/ideal-core-ui'

const DatePicker = ({
  disabled,
  className,
  cy,
  disabledDays,
  onChange,
  value,
  placeholder,
  keyProp
}) => {
  const [selected, setSelected] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [isPopperOpen, setIsPopperOpen] = useState(false)

  const popperRef = useRef(null)
  const [popperElement, setPopperElement] = useState(null)

  const popper = usePopper(popperRef.current, popperElement, {
    placement: 'bottom-start'
  })

  useEffect(() => {
    if (!value) {
      setSelected(undefined)
      setInputValue('')
    }
    if (value && value !== selected) {
      setSelected(moment(value, getDateFormat()).toDate())
      setInputValue(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const closePopper = () => {
    setIsPopperOpen(false)
  }

  const handleClick = () => {
    !disabled && setIsPopperOpen(true)
  }

  const handleDaySelect = date => {
    setSelected(date)
    if (date) {
      setInputValue(moment(date).format(getDateFormat()))
      closePopper()
      onChange(date)
    } else {
      setInputValue('')
    }
  }

  return (
    <div key={keyProp} className={cn(s.dayPickerWrapper, className)} data-key={keyProp}>
      <div ref={popperRef}>
        <input
          type="text"
          placeholder={placeholder ?? getDateFormat()}
          value={inputValue}
          onClick={handleClick}
          onChange={() => {}}
          disabled={disabled}
          data-cy={cy}
        />
      </div>
      {isPopperOpen && (
        <OutsideClickContainer styles={{ height: 'initial' }} closeComponent={closePopper}>
          <div
            tabIndex={-1}
            style={popper.styles.popper}
            {...popper.attributes.popper}
            ref={setPopperElement}
            className={s.popper}
          >
            <DayPicker
              captionLayout="dropdown-buttons"
              fromYear={2000}
              toYear={2100}
              initialFocus={isPopperOpen}
              mode="single"
              defaultMonth={selected}
              selected={selected}
              onSelect={handleDaySelect}
              className={className}
              disabled={disabledDays}
            />
          </div>
        </OutsideClickContainer>
      )}
    </div>
  )
}

export default DatePicker
